
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA  à Lyon à partir de 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Lyon certifiée Google Partner qui a pour but d’aider les entreprises lyonnaises dans l’acquisition de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Lyon à partir de 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Lyon certifiée Google Partner qui a pour but d’aider les entreprises lyonnaises dans l’acquisition de nouveaux clients.",
        },
      ],
    };
  },
};
